import '../stylesheets/internal_balances.css';

import React from 'react';

const currencies = ['CHF', 'EUR', 'USD', 'GBP', 'DKK'];

export default function InternalBalances({ account, t }) {
  const balances = currencies
    .map((currency) => ({
      currency,
      amount: Number(account?.[`balance_${currency}`] || 0),
    }))
    .filter(({ amount }) => Number.isFinite(amount) && amount !== 0);

  return (
    <section className='internal-balances'>
      <h3 className='internal-balances__heading'>
        {t('Account.internalBalances', { defaultValue: 'Internal balances' })}
      </h3>
      {balances.length ? (
        <ul className='internal-balances__list'>
          {balances.map(({ currency, amount }) => (
            <li
              key={currency}
              className={`internal-balances__item${amount < 0 ? ' internal-balances__item--negative' : ''}`}>
              <span className='internal-balances__currency'>{currency}</span>
              <strong className='internal-balances__amount'>
                {amount.toFixed(2)}
              </strong>
            </li>
          ))}
        </ul>
      ) : (
        <p className='internal-balances__empty'>
          {t('Account.noBalance', { defaultValue: 'No internal balance' })}
        </p>
      )}
    </section>
  );
}
